import { ReactWrapperComponent } from '@ami/angular/core/react-interop';
import { CustomerInventoryApp } from '@ami/react/customer';
import {
  Component,
  Injector,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import * as iframeResizerContentWindow from 'iframe-resizer';
import * as smoothscroll from 'smoothscroll-polyfill';

@Component({
  standalone: true,
  template: ``,
  styleUrls: ['customer-inventory-v1.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CustomerInventoryV1Component extends ReactWrapperComponent implements OnInit {

  protected getElement(onHasUnsavedChangesChangedFn: (x: boolean) => void, injector:Injector) {
    return <CustomerInventoryApp hasUnsavedChangesChanged={(x: boolean) => onHasUnsavedChangesChangedFn(x)} injector={ injector } />;
  }

  ngOnInit(): void {
    console.log('iframeResizerContentWindow:', iframeResizerContentWindow); // needed in order to get the reference loaded
    smoothscroll.polyfill();
  }
}
